import { isString } from '@vue/shared'
import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { UPDATE_MODEL_EVENT } from '@sgui-plus/utils/constants'
import { useSizeProp } from '@sgui-plus/hooks'
import type { ExtractPropTypes } from 'vue'

type AutoSize = { minRows?: number; maxRows?: number } | boolean

export const inputProps = buildProps({
  size: useSizeProp,
  disabled: Boolean,
  modelValue: {
    type: definePropType<string | number | null | undefined>(undefined),
    default: '',
  },
  autosize: {
    type: definePropType<AutoSize>([Boolean, Object]),
    default: false,
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  canSee: {
    type: Boolean,
    default: false,
  },
  showWordLimit: {
    type: Boolean,
    default: false,
  },
  showSearch: {
    type: Boolean,
    default: false
  },
  validateEvent: {
    type: Boolean,
    default: true,
  }
} as const)
export type InputProps = ExtractPropTypes<typeof inputProps>

export const inputEmits = {
  [UPDATE_MODEL_EVENT]: (value: string) => isString(value),
  onInput: (value: string) => isString(value),
  onChange: (value: string) => isString(value),
  onFocus: (evt: FocusEvent) => evt instanceof FocusEvent,
  onBlur: (evt: FocusEvent) => evt instanceof FocusEvent,
  onClear: () => true,
  mouseleave: (evt: MouseEvent) => evt instanceof MouseEvent,
  mouseenter: (evt: MouseEvent) => evt instanceof MouseEvent,
  compositionstart: (evt: CompositionEvent) => evt instanceof CompositionEvent,
  compositionupdate: (evt: CompositionEvent) => evt instanceof CompositionEvent,
  compositionend: (evt: CompositionEvent) => evt instanceof CompositionEvent,
}
export type InputEmits = typeof inputEmits
